<template>
  <div id="e3d-payment-checkout" class="container">

    <h3>Seleziona il metodo di pagamento</h3>

    <div id="payment-modes" class="clearfix">
      <!--   Se non è un'utenza "pub. amm." allora lo mostro"   -->
      <div v-if="typeUser !== 2" class="text-center noPadding payment-mode border-right bonifico-bancario"
           v-on:click="mode = 0"
           v-bind:class="[{'col-xs-4': typeUser === 0}, {'col-xs-6': typeUser === 1}]">
        <img src="../../static/img/bonifico.png" v-if="mode === 0">
        <img src="../../static/img/bonificoGrigio.png" v-else>
        <p class="text-center" v-bind:class="{'selected': mode === 0}">
          BONIFICO BANCARIO
        </p>
      </div>

      <!--   Se non è un'utenza "pub. amm." allora lo mostro"   -->
      <div v-if="typeUser !== 2" class="text-center noPadding payment-mode paypal"
           v-on:click="paypalCheckout()"
           v-bind:class="[{'col-xs-4 border-right': typeUser === 0}, {'col-xs-6': typeUser === 1}]">
        <img src="../../static/img/PayPalLogo.png" v-if="mode === 1">
        <img src="../../static/img/PayPalLogoGrigio.png" v-else>
        <p class="text-center" v-bind:class="{'selected': mode === 1}">PAYPAL O CARTA DI CREDITO</p>
      </div>

      <!--   Se non è un'utenza "privato" allora lo mostro"   -->
      <div v-if="typeUser !== 1" class="text-center noPadding payment-mode no-border richiedi-offerta"
           v-on:click="mode = 2"
           v-bind:class="[{'col-xs-4 border-right': typeUser === 0}, {'col-xs-12': typeUser === 2}]">
        <img src="../../static/img/tax.png" v-if="mode === 2">
        <img src="../../static/img/taxGrigio.png" v-else>
        <p class="text-center" v-bind:class="{'selected': mode === 2}">
          RICHIEDI OFFERTA
        </p>
      </div>
    </div>

    <div id="payment-shipment-body" class="clearfix">
      <div class="clearfix col-xs-6 body-bonifico-offerta" v-if="mode === 0">
        <div class="noPadding col-xs-12 coordinate-bancarie">
          <div class="noPadding col-xs-12">Banca d'appoggio</div>
          <div class="noPadding col-xs-12 coordinate-val">UBI Banca</div>
        </div>

        <div class="noPadding col-xs-12 coordinate-bancarie">
          <div class="noPadding col-xs-12">IBAN</div>
          <div class="noPadding col-xs-12 coordinate-val">IT96S0311150260000000008438</div>
        </div>

        <div class="noPadding col-xs-12 coordinate-bancarie">
          <div class="noPadding col-xs-12">Causale</div>
          <div class="noPadding col-xs-12 coordinate-val">
            {{getCausalText()}}
          </div>
          <!-- manca l'id del Rossetti che non può essere inserito -->
        </div>

        <div class="noPadding col-xs-12 shipment-detail">
          <div class="noPadding col-xs-12">Dettagli spedizione</div>
          <div class="noPadding col-xs-12 ship-date">
            La spedizione sar&agrave; effettuata in {{5 * (this.shipData.type + 1)}} giorni lavorativi a partire dal
            giorno di ricezione del bonifico
          </div>
        </div>
      </div>

      <div class="clearfix col-xs-12 body-bonifico-offerta" v-if="mode === 2">
        <div class="noPadding col-xs-12 label-note">
          <div class="noPadding col-xs-12">Qui puoi inserire delle note al tuo ordine</div>
          <textarea class="note" :value="note" @input="setValue($event, 'note')"></textarea>
        </div>
      </div>

      <div id="body-paypal" v-if="mode === 1">
      </div>

      <div v-if="attesaRichiestaPreventivo" class="loader-mask-config">
        <!-- Contenitore necessario per il loader che pulsa -->
        <div class="loader-config">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>

    <input v-if="mode === 0" class="btn btn-md btn-stroke button-blu-effect right button-new-style"
           type="submit" value="Procedi all'ordine" v-on:click="checkout()" :disabled="attesaRichiestaPreventivo">

    <input v-if="mode === 2" class="btn btn-md btn-stroke button-blu-effect right button-new-style"
           type="submit" value="Richiedi offerta" v-on:click="checkout()" :disabled="attesaRichiestaPreventivo">

    <input class="btn btn-md btn-stroke button-blu-effect right go-back button-new-style"
           type="submit" value="Torna al carrello" v-on:click="goBack()" :disabled="attesaRichiestaPreventivo">
  </div>
</template>

<script>
  import {Validator} from 'vee-validate'
  import swal from 'sweetalert2'
  import {progressbar} from 'vue-strap'
  import {momentMixin} from '../mixins/momentMixin'
  import moment from 'moment'
  import {generalMixins} from '../mixins/generalMixins'

  const axios = require('axios')
  moment.locale('it')

  export default {
    name: 'PaymentCheckout',
    components: {
      Validator,
      progressbar,
      swal
    },
    mixins: [momentMixin, generalMixins],
    data () {
      return {
        mode: -1,
        iban: '', //aa1111111111111111111111111
        attesaRichiestaPreventivo: false,
        shipData: {
          type: -1,
          date: ''
        },
        typeUser: 0,
        note: '',
        userData: {
          ragSoc: '',
          typeUser: ''
        },
        cartItems: [],
        thereAreErrors: false
      }
    },
    mounted: function () {
      window.scrollTo(0, 0)
      this.getShipment()
      this.getTypeUser()
      this.loadCartItems()
    },
    methods: {
      setValue: function (event, variableName) {
        let variableValue = event.target.value
        this[variableName] = variableValue.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      },
      getTypeUser: function () {
        axios.get('/api/v1/carts/' + this.getIdCart() + '/user-data')
          .then(response => {
            if (response.status === 200 && response.data.code === 20) {
              this.typeUser = response.data.result.type_user
              this.userData.ragSoc = response.data.result.client_rag_soc
              this.userData.typeUser = this.getDescTypeUser(response.data.result.type_user)
            }
          })
      },
      loadCartItems: function () {
        axios.get('/api/v1/carts/' + this.getIdCart())
          .then((response) => {
            this.cartItems = response.data.result.rows
            this.thereAreErrorsFunc()
          })
          .catch(() => {
            console.log('paymentCheckout')
            this.resetSiteDueInvalidCart()
          })
      },
      getDescTypeUser: function (code) {
        let res = ''

        switch (code) {
          case 0:
            res = 'Azienda'
            break
          case 1:
            res = 'Privato'
            break
          case 2:
            res = 'Pubblica Amministrazione'
            break
        }

        return res
      },
      getCausalDate: function () {
        return moment().format('DD-MM-YY')
      },
      getCausalText: function () {
        let causal = '3D ' + this.getCausalDate() + ' ' + (this.userData.ragSoc && this.userData.ragSoc !== '' ? this.userData.ragSoc : '') + ' ' + this.userData.typeUser
        return causal.substring(0, 50)
      },
      getIdCart: function () {
        return localStorage.getItem('id_cart')
      },
      checkout: function () {
        this.thereAreErrorsFunc()

        if (this.thereAreErrors) {
          swal({
            title: 'Attenzione',
            type: 'warning',
            html: 'Attenzione! Uno o più file caricati presentano alcuni aspetti tecnici da approfondire. I tecnici di Elmec 3D effettueranno un\'analisi e la ricontatteranno a breve.',
            showCancelButton: true,
            cancelButtonText: 'Contattaci',
            cancelButtonColor: '#d33'
          }).then((result) => {
            if (result.value) {
              this.setPaymentMode(() => {
                this.attesaRichiestaPreventivo = true
                if (this.mode === 0 || this.mode === 1 || this.mode === 2) {
                  this.$validator.validateAll('coordinate').then(result => {
                    if (result) {
                      let params = {
                        note: this.note
                      }
                      axios.put('/api/v1/carts/' + this.getIdCart() + '/checkout', params)
                        .then(res => {
                          if (res.status === 200 && res.data.code === 20) {
                            let text = ''
                            if (this.mode == 0) {
                              text = 'Checkout effettuato con successo, procedi con l\'ordine'
                            }
                            if (this.mode == 2) {
                              text = 'Checkout effettuato con successo, abbiamo inviato una mail ai nostri uffici per prendere in carico la sua richiesta'
                            }
                            swal('Checkout', text, 'success').then((result) => {
                              localStorage.removeItem('id_cart')
                              this.$router.push({name: 'e3d'})
                            })
                          } else {
                            swal('Checkout', 'Errore durante la fase di checkout', 'error')
                          }
                          this.attesaRichiestaPreventivo = false
                        })
                        .catch(err => {
                          this.attesaRichiestaPreventivo = false
                          if (err.response.status === 400) this.badRequestModal(err.response.data)
                          else {
                            if ('error' in err.response.data && err.response.data.error !== '') {
                              swal('Checkout', err.response.data.error, 'error')
                            } else {
                              swal('Checkout', 'Errore durante la fase di checkout', 'error')
                            }
                          }
                        })
                    }
                  })
                }
              })
            } else {
              window.location.href = 'mailto:info@elmec3d.com?subject=Domande%20ordine%20' + this.getIdCart()
            }
          })
        } else {
          this.setPaymentMode(() => {
            this.attesaRichiestaPreventivo = true
            if (this.mode === 0 || this.mode === 1 || this.mode === 2) {
              this.$validator.validateAll('coordinate').then(result => {
                if (result) {
                  let params = {
                    note: this.note
                  }
                  axios.put('/api/v1/carts/' + this.getIdCart() + '/checkout', params)
                    .then(res => {
                      if (res.status === 200 && res.data.code === 20) {
                        let text = ''
                        if (this.mode == 0) {
                          text = 'Checkout effettuato con successo, procedi con l\'ordine'
                        }
                        if (this.mode == 2) {
                          text = 'Checkout effettuato con successo, abbiamo inviato una mail ai nostri uffici per prendere in carico la sua richiesta'
                        }
                        swal('Checkout', text, 'success').then((result) => {
                          localStorage.removeItem('id_cart')
                          this.$router.push({name: 'e3d'})
                        })
                      } else {
                        swal('Checkout', 'Errore durante la fase di checkout', 'error')
                      }
                      this.attesaRichiestaPreventivo = false
                    })
                    .catch(err => {
                      this.attesaRichiestaPreventivo = false
                      if (err.response.status === 400) this.badRequestModal(err.response.data)
                      else {
                        if ('error' in err.response.data && err.response.data.error !== '') {
                          swal('Checkout', err.response.data.error, 'error')
                        } else {
                          swal('Checkout', 'Errore durante la fase di checkout', 'error')
                        }
                      }
                    })
                }
              })
            }
          })
        }
      },
      setPaymentMode: function (cb) {
        if (this.mode == 0 || this.mode == 1 || this.mode == 2) {
          axios.put('/api/v1/carts/' + this.getIdCart() + '/payment/' + parseInt(this.mode))
            .then(res => {
              if (res.status === 200 && res.data.code === 20) {
                if (cb) cb()
              } else {
                swal('Aggiornamento modalità di pagamento', 'Errore durante la fase di aggiornamento della modalità di pagamento', 'error')
              }
            })
            .catch(res => {
              swal('Aggiornamento modalità di pagamento', 'Errore durante la fase di aggiornamento della modalità di pagamento', 'error')
            })
        }
      },
      getShipment: function () {
        axios.get('/api/v1/carts/' + this.getIdCart() + '/shipment')
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code === 20) {
                this.shipData.type = res.data.result.shipment
                let date = this._addWeekdays(moment(), 5 * (this.shipData.type + 1))
                this.shipData.date = date.format('dddd') + ' ' + date.format('DD / MM')
              }
            }
          })
      },
      goBack: function () {
        this.$router.push({name: 'e3d'})
      },
      paypalCheckout: function () {
        this.thereAreErrorsFunc()

        if (this.thereAreErrors) {
          swal({
            title: 'Attenzione',
            type: 'warning',
            html: 'Attenzione! Uno o più file caricati presentano alcuni aspetti tecnici da approfondire. I tecnici di Elmec 3D effettueranno un\'analisi e la ricontatteranno a breve.',
            showCancelButton: true,
            cancelButtonText: 'Contattaci',
            cancelButtonColor: '#d33'
          }).then((result) => {
            if (result.value) {
              this.mode = 1
              this.setPaymentMode(() => {
                this.attesaRichiestaPreventivo = true

                axios.post('/api/v1/carts/buy/' + this.getIdCart())
                  .then(res => {
                    if (res.status === 200) {
                      this.mode = 1
                      this.attesaRichiestaPreventivo = false
                      window.location.href = res.data.result.url
                    }
                  })
                  .catch((err) => {
                    this.mode = -1
                    this.attesaRichiestaPreventivo = false
                    if ('error' in err.response.data && err.response.data.error !== '') {
                      swal('Checkout', err.response.data.error, 'error')
                    } else {
                      swal('Checkout', 'Errore durante la fase di checkout', 'error')
                    }
                  })
              })
            } else {
              window.location.href = 'mailto:info@elmec3d.com?subject=Domande%20ordine%20' + this.getIdCart()
            }
          })
        } else {
          this.mode = 1
          this.setPaymentMode(() => {
            this.attesaRichiestaPreventivo = true

            axios.post('/api/v1/carts/buy/' + this.getIdCart())
              .then(res => {
                if (res.status === 200) {
                  this.mode = 1
                  this.attesaRichiestaPreventivo = false
                  window.location.href = res.data.result.url
                }
              })
              .catch((err) => {
                this.mode = -1
                this.attesaRichiestaPreventivo = false
                if ('error' in err.response.data && err.response.data.error !== '') {
                  swal('Checkout', err.response.data.error, 'error')
                } else {
                  swal('Checkout', 'Errore durante la fase di checkout', 'error')
                }
              })
          })
        }
      },
      thereAreErrorsFunc: function () {
        let there_are_errors = false

        this.cartItems.forEach(ic => {
          let arrErr = JSON.parse(ic.warning.replace(/'/g, '"'))
          there_are_errors = there_are_errors || arrErr.length > 0
        })

        this.thereAreErrors = there_are_errors
      }
    }
  }
</script>


<style lang="less">
  #e3d-payment-checkout {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    margin-bottom: 30px;

    .loader-mask {
      opacity: 0.5;
    }

    .noPadding {
      padding: 0;
    }

    .text-center {
      text-align: center;
    }

    .right {
      float: right;
    }

    .go-back {
      margin-right: 40px;
    }

    #payment-modes {
      margin: 50px 0 20px 0;

      .payment-mode {
        height: 120px;
        cursor: pointer;

        &:hover {
          p {
            color: #4285F4;
          }
        }

        p {
          margin: 0;
          padding-top: 14px;
          font-weight: bold;
          font-size: 17px;
          cursor: pointer;

          &.selected {
            color: #4285F4;
          }
        }

        img {
          height: 70px;
        }

        &.border-right {
          border-right: 1px solid #c1c1c1;
        }

        &.no-border {
          border: none;
        }
      }
    }

    #payment-shipment-body {
      input[type=text] {
        background-color: #FFFFFF;
        border-bottom: 1px solid #fbbc05;
        margin-bottom: 0;

        &:focus {
          outline: none;
          border: none;
          border-bottom: 1px solid #fbbc05;
        }
      }

      .loader-mask-config {
        opacity: 0.5;
        // TEST
        position: absolute;
        height: 100%;
        // END TEST
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 99999;

        &.loader-render-model {
          position: absolute;
        }

        .loader-config {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 50px;
          height: 50px;
          font-size: 0;
          color: #4285F4;
          display: inline-block;
          margin: -25px 0 0 -25px;
          text-indent: -9999em;
          -webkit-transform: translateZ(0);
          -ms-transform: translateZ(0);
          transform: translateZ(0);

          div {
            background-color: #4285F4;
            display: inline-block;
            float: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 50px;
            height: 50px;
            opacity: .5;
            border-radius: 50%;
            -webkit-animation: ballPulseDouble 2s ease-in-out infinite;
            animation: ballPulseDouble 2s ease-in-out infinite;

            &div:last-child {
              -webkit-animation-delay: -1s;
              animation-delay: -1s;
            }
          }
        }

        .percentage-upload {
          text-align: center;
          font-size: 30px;
          position: absolute;
          top: 30%;
          width: 100%;
        }
      }

      .body-bonifico-offerta {
        margin: 20px 0;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;

        .coordinate-bancarie, .label-note {
          font-family: "Open Sans", sans-serif;
          font-size: 16px;
          color: #4285f4;
          margin: 20px 0;

          .coordinate-val {
            color: #333;
          }
        }

        .note {
          margin-top: 15px;
          width: 100%;
          min-height: 200px;
          color: #626366;
          background-color: white;
          border: 1px solid #fbbc05;
        }
      }

      .shipment-detail {
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        color: #4285f4;
        margin: 20px 0;

        .ship-date {
          color: #333;
        }
      }
    }

    .button-new-style {
      background-color: #4285F4;
      border-radius: 15px;
      color: white;
      font-weight: bold;
      width: 200px;
      padding: 0;

      &:hover {
        background-color: #004B96;
        border: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PaymentCheckout.vue